<nav class="navbar navbar-expand-sm navbar-dark bg-dark p-1">
  <div class="container">
    <a class="navbar-brand">Ecademictube</a>
    <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" (click)="onLogout()" style="cursor: pointer;">
            <i class="fas fa-user-times"></i> Logout
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- HEADER -->
<header id="main-header" class="py-2 bg-info text-white">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h2>
          <i class="fa fa-user-circle" aria-hidden="true"></i> Welcome {{ subAdminName }}
        </h2>
      </div>
    </div>
  </div>
</header>

<!-- ASSIGNED SESSIONS -->
<!-- <div class="container mt-5">
  <div class="card">
    <div class="card-header text-center">
      <h4>Assigned Sessions</h4>
    </div>
    <table class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <th>#</th>
          <th>Topic</th>
          <th>Date</th>
          <th>Status</th>
          <th>Visit</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fa fa-comments"></i> Chatroom
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>
        <tr>
          <td>1</td>
          <td>Physics</td>
          <td>May 10 2018</td>
          <td>Finished</td>
          <td>
            <a class="btn btn-info text-white">
              <i class="fas fa-angle-double-right"></i> Session
            </a>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div> -->

<div class="container mt-4">
  <div class="row" style="border: 1px solid silver; padding: 10px;">

    <div class="row mb-1">
      <div class="col-4">
        <div class="py-2 bg-dark text-white text-center">
          <b>Assigned Sessions</b>
        </div>
      </div>
      <div class="col-8">
        <div class="py-2 bg-dark text-white text-center">
          <b>Chatroom</b>
        </div>
      </div>
    </div>

    <!-- CHAT-WINDOW -->
    <div class="row chat-window">
      <div class="col-4 session-list bg-light">

        <!-- <div class="session-card my-2" *ngFor="let session of latestSessionList">
          <div class="row">
            <div class="col-7">
              <h5 class="card-title">{{ session.sessionTopic }}</h5>
              <h6 class="card-subtitle mb-2 text-muted">{{ session.startTime }}</h6>
              <p class="card-text">{{ session.sessionCode }}</p>
            </div>
            <div class="col-5 text-center">
              <b *ngIf="session.status=='UPCOMING'" style="color: blue;">Upcoming</b>
              <b *ngIf="session.status=='LIVE'" style="color: green;"><i class="fa fa-circle" aria-hidden="true"></i> Live</b>
              <b *ngIf="session.status=='COMPLETE'" style="text-align: right;">Complete</b>
            </div>
          </div>
        </div> -->

        <a style="cursor: pointer;" *ngFor="let session of assignedSessionList" (click)="onSessionSelect(session._id)">
          <div class="card my-2">
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <h5 class="card-title">{{ session.sessionTopic }}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">{{ session.startTime }}</h6>
                  <p class="card-text">{{ session.sessionCode }}</p>
                </div>
                <div class="col-4 text-center">
                  <b *ngIf="session.status=='UPCOMING'" style="color: blue;">Upcoming</b>
                  <b *ngIf="session.status=='LIVE'" style="color: green;"><i class="fa fa-circle" aria-hidden="true"></i> Live</b>
                  <b *ngIf="session.status=='COMPLETE'" style="text-align: right;">Complete</b>
                </div>
              </div>
            </div>
          </div>
        </a>

      </div>
      <div class="col-8 chatroom">
        <app-ecachatroom></app-ecachatroom>
      </div>
    </div>
  </div>
</div>


<!-- FOOTER -->
<footer id="main-footer" class="bg-dark text-white mt-5 p-4 sticky-bottom">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <b>Ecademictube - Live Sessions</b>
        <p>Copyright © {{ currentYear }}. All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>
